import Stripe from "stripe";

export interface IInvoice extends Stripe.Invoice { };

export interface IUpcomingInvoice extends IInvoice {
    id: null;
    subscription: string;
}
export interface IInvoiceItem extends Stripe.InvoiceItem {
    metadata: {
        bigcommerce_order_id: string;
        resourceId:string;
        resourceType: string;
        organization: string;
    };
}

export interface IInvoiceListParams extends Stripe.InvoiceListParams { }

export interface IStripeSubscription extends Stripe.Subscription {
    customerName: string;
    customerId: string;
    customer: string;
    plan: any;
    quantity: number;
}

export interface ICancelSubscriptionQuery {
    invoice_now?: boolean;
    prorate?: boolean;
}
